import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import minicartQuery from '~/graphql/cart/minicart.gql';
import createNewCartMutation from '~/graphql/cart/createNewCart.gql';
import addProductsToCartMutation from '~/graphql/cart/addProductsToCart.gql';
import addCustomizableProductToCartMutation from '~/graphql/cart/addCustomizableProductToCart.gql';
import updateCartMutation from '~/graphql/cart/updateCart.gql';

function fetchCart(_x, _x2, _x3) {
  return _fetchCart.apply(this, arguments);
}

function _fetchCart() {
  _fetchCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context, reference, token) {
    var data;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return context.app.apolloProvider.defaultClient.query(_objectSpread(_objectSpread({
              query: minicartQuery,
              errorPolicy: 'all',
              fetchPolicy: 'network-only'
            }, token && {
              context: {
                headers: {
                  Authorization: "Bearer ".concat(token)
                }
              }
            }), {}, {
              variables: {
                reference: reference
              }
            }));

          case 2:
            data = _context.sent;
            return _context.abrupt("return", data);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchCart.apply(this, arguments);
}

function createCart(_x4, _x5) {
  return _createCart.apply(this, arguments);
}

function _createCart() {
  _createCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(context, token) {
    var _yield$context$app$ap, data;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return context.app.apolloProvider.defaultClient.mutate(_objectSpread({
              mutation: createNewCartMutation
            }, token && {
              context: {
                headers: {
                  Authorization: "Bearer ".concat(token)
                }
              }
            }));

          case 2:
            _yield$context$app$ap = _context2.sent;
            data = _yield$context$app$ap.data;
            return _context2.abrupt("return", data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _createCart.apply(this, arguments);
}

function addCart(_x6, _x7) {
  return _addCart.apply(this, arguments);
}

function _addCart() {
  _addCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(context, payload) {
    var response;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return context.app.apolloProvider.defaultClient.mutate(_objectSpread(_objectSpread({
              mutation: addProductsToCartMutation
            }, payload.token && {
              context: {
                headers: {
                  Authorization: "Bearer ".concat(payload.token)
                }
              }
            }), {}, {
              variables: {
                cart: payload.cart,
                products: [_objectSpread({
                  reference: payload.reference,
                  quantity: payload.quantity
                }, payload.offer && {
                  offer: payload.offer
                })]
              }
            }));

          case 2:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _addCart.apply(this, arguments);
}

function addCartCustomizable(_x8, _x9, _x10, _x11) {
  return _addCartCustomizable.apply(this, arguments);
}

function _addCartCustomizable() {
  _addCartCustomizable = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(context, cart, token, payload) {
    var _yield$context$app$ap2, data;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return context.app.apolloProvider.defaultClient.mutate(_objectSpread(_objectSpread({
              mutation: addCustomizableProductToCartMutation
            }, token && {
              context: {
                headers: {
                  Authorization: "Bearer ".concat(token)
                }
              }
            }), {}, {
              variables: {
                cart: cart,
                reference: payload
              }
            }));

          case 2:
            _yield$context$app$ap2 = _context4.sent;
            data = _yield$context$app$ap2.data;
            return _context4.abrupt("return", data);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _addCartCustomizable.apply(this, arguments);
}

function updateCart(_x12, _x13) {
  return _updateCart.apply(this, arguments);
}

function _updateCart() {
  _updateCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(context, payload) {
    var _yield$context$app$ap3, data;

    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return context.app.apolloProvider.defaultClient.mutate(_objectSpread(_objectSpread({
              mutation: updateCartMutation
            }, payload.token && {
              context: {
                headers: {
                  Authorization: "Bearer ".concat(payload.token)
                }
              }
            }), {}, {
              variables: {
                cart: payload.cart,
                items: [{
                  reference: payload.reference,
                  quantity: payload.quantity
                }]
              }
            }));

          case 2:
            _yield$context$app$ap3 = _context5.sent;
            data = _yield$context$app$ap3.data;
            return _context5.abrupt("return", data);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _updateCart.apply(this, arguments);
}

export { fetchCart, createCart, addCart, updateCart, addCartCustomizable };